import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import dayjs from 'dayjs';
export default {
  data: function data() {
    return {
      dayjs: dayjs,
      value: new Date(),
      show: false,
      device_list: []
    };
  },
  mounted: function mounted() {
    this.getDevice();
  },
  methods: {
    getDevice: function getDevice() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _res$data$;
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$api['monitorQueryJoinPower']({
                page: 1,
                limit: 10,
                labId: localStorage.getItem('labId'),
                deviceCategory: 'Condition'
              });
            case 2:
              res = _context.sent;
              _this.device_list = res.data || [];
              _this.deviceId = (_res$data$ = res.data[0]) === null || _res$data$ === void 0 ? void 0 : _res$data$.id;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    backClick: function backClick() {
      this.$router.back();
    }
  }
};